module.exports = __webpack_public_path__ + "static/media/nodejs.0ca02dd3.png";